import React  from "react";

const About = () => {
    return (
        <>

		<div className="product">
			<h2 id="hot" className="product-title">30Shine - Điểm Tựa Cho Việc Lớn</h2>
			<div className="product-title-3"><i>"Hãy cho tôi một điểm tựa, tôi sẽ nâng cả thế giới." - Archimedes</i>
				<br />Mỗi người đàn ông đều có một hành trình riêng, một thế giới muốn chinh phục
				<br />Có người đang tiến về đích, có người vẫn đang tìm hướng đi
				<br />Có người biết chính xác điều mình muốn, có người đang từng bước khám phá
				<br /><b>Dù anh đang ở đâu trên hành trình ấy – bản lĩnh và sự tự tin luôn có trong chính anh</b>
				<br />30Shine không tạo ra chúng. <b>Chúng tôi là điểm tựa</b> , giúp anh thể hiện trọn vẹn phong thái,
				khí chất và sẵn sàng cho những điều quan trọng phía trước
			</div>
			<div className="clear"></div>
			<div className="banner">
				<img className="cuocthi-img" title="cuocthi30shine" alt = "none" src="img/cuocthi/thumbnail-about.jpg" />
			</div>
			<div className="clear"></div>
			<h2 id="hot" className="product-title">Kiểu Tóc Đẹp Không Phải Đích Đến – Mà Là Điểm Khởi Đầu</h2>
			<div className="product-title-3">Một kiểu tóc đẹp <b>không chỉ để ngắm nhìn – mà còn để cảm nhận:</b>
				<br />Cảm nhận sự<b> thoải mái, tự tin, sẵn sàng</b>
				<br />Cảm nhận một phiên bản <b>tốt hơn của chính mình</b>
				<br />Với gần <b>150 salon trên toàn quốc</b> , công nghệ hiện đại và đội ngũ thợ tận tâm, 30Shine không
				chỉ mang đến một diện mạo mới. <b>Chúng tôi giúp anh luôn trong trạng thái tốt nhất – để đón nhận bất kỳ
					điều gì đang chờ phía trước</b>
			</div>
			<div className="clear"></div>
			<h2 id="hot" className="product-title">Ý nghĩa logo và thương hiệu</h2>
			<div className="product-title-3"> 30Shine đại diện cho tuổi 30 toả sáng của mỗi người đàn ông - độ tuổi mang ý
				nghĩa biểu tượng mạnh mẽ nhất đại diện cho ngọn lửa thành công, khát vọng chiến thắng và ý chí vươn lên
				của bất kỳ người đàn ông hiện đại nào. Tên gọi được thể hiện qua Logo nam nhân tỏa sáng cùng font chữ
				hiện đại và công nghệ như một sự khẳng định mạnh mẽ cho tinh thần chiến thắng, khát vọng thành công.
			</div>
			<div className="product-title-3">Nhận diện mới của 30Shine nổi bật với màu xanh Blue Royal đại diện hình mẫu
				người khởi tạo với ý chí không ngừng đổi mới, luôn nhìn ra cơ hội để thay đổi cuộc chơi, phá bỏ quan
				niệm cũ.
				<br /><br />Sự lựa chọn của 30Shine là một định vị không hào nhoáng, nhưng chứa đựng mơ ước lớn của
				doanh nghiệp 30Shine là hiện đại hoá ngành tóc ở Việt Nam.
			</div>
			<div className="clear"></div>
			<h2 id="hot" className="product-title">WILLS – Văn Hoá Tinh Thần Của Những Người Dám Tiến Lên</h2>
			<div className="product-title-3">Ở 30Shine, chúng tôi không chỉ tạo ra diện mạo tuyệt vời – chúng tôi phục vụ
				những người đàn ông muốn tốt hơn mỗi ngày
				Dù anh đang <b>bắt đầu, bứt phá hay khẳng định chính mình,</b> tinh thần<b> WILLS</b> luôn đồng hành:
			</div>
			<div className="product-title-3">
				<ul>
					<li><b>W - Warrior</b> (Chiến binh) – Kiên cường, không lùi bước trước thử thách</li>
					<li><b>I - Intervention</b> (Can thiệp) – Không đợi thời điểm hoàn hảo, mà tạo ra nó</li>
					<li><b>L - Learning</b> (Ham học hỏi) – Phát triển không giới hạn, không ngừng nâng cấp bản thân
					</li>
					<li><b>L - Leadership</b> (Đổi mới) – Luôn sáng tạo, chủ động dẫn đầu sự thay đổi</li>
					<li><b>S - Sincerity</b> (Chân thành) – Minh bạch, đáng tin cậy, tạo dựng giá trị bền vững</li>

				</ul>
			</div>
			<div className="product-title-3"><b>Không có đúng hay sai – chỉ có phiên bản tốt nhất của chính mình, và 30Shine
					ở đây để giúp anh tự tin thể hiện điều đó</b></div>

			<div className="clear"></div>
			<h2 id="hot" className="product-title">Sứ Mệnh – Tôn Vinh Đôi Bàn Tay Tài Hoa Người Thợ Việt</h2>
			<div className="product-title-3"> 30Shine không chỉ là điểm tựa giúp đàn ông thể hiện phong độ, mà còn mang
				trong mình một sứ mệnh lớn hơn:
				<br /><b>Tôn vinh và nâng tầm đôi bàn tay tài hoa của người thợ Việt trên bản đồ thế giới</b>
				<br />Tay nghề con người Việt Nam không chỉ giỏi – mà có thể vươn xa
				<br />Bằng việc không ngừng đổi mới, nâng cao chất lượng dịch vụ và xây dựng môi trường phát triển
				chuyên nghiệp, 30Shine giúp người thợ Việt phát triển bản thân, nghề nghiệp và vị thế trong ngành tóc
				toàn cầu
				<br /><b>Từ bàn tay Việt – vươn tới những tầm cao mới</b>
			</div>
			<div className="clear"></div>
			<h2 id="hot" className="product-title">Ai Cũng Có Việc Lớn Của Riêng Mình – Chỉ Cần Một Điểm Tựa</h2>
			<div className="product-title-3"> Không có lộ trình nào giống nhau
				<br />Không có đích đến nào là duy nhất
			</div>
			<div className="clear"></div>
			<h2 id="hot" className="product-title">30Shine – Điểm Tựa Cho Việc Lớn</h2>
			<div className="product-title-3"> Dù anh đang ở đâu trên hành trình –<b> chỉ cần sẵn sàng, thế giới này là của
					anh</b>
			</div>

			<div className="clear"></div>
			<h2 id="timmap" className="product-title">TÌM 30SHINE GẦN NHẤT</h2>
			<div className="product-title-2">Để xe thuận tiện an toàn, bản đồ dẫn đường chi tiết (hàng trăm Salon)</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem1" alt = "none" src="img/diadiem/hanoi.png" /> <br /><br />
					<a href="none" className="diadiem-name">HÀ NỘI</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/hochiminh.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">HỒ CHÍ MINH</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/danang.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">ĐÀ NẴNG</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/hungyen.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">ĐỊA ĐIỂM KHÁC</a>
				</div>
			</div>
		</div>
	</>
    );
};

export default About;